
export enum postOwnerType {
    SUPPLIER = 'supplier',
    FARMER =  'farmer'
}